<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.price_lists')"/>
        <div class="col-12 nopads mt-2">
            <!-- Tabs -->
            <ul class="nav nav-tabs routa-tabs">
                <li class="nav-item routa-tab-nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                        {{ $t('pricing_models.weight_distance_price_lists') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                        {{  $t('pricing_models.area_price_lists')  }}
                    </button>
                     </li>
            </ul>
            <!-- Content -->
            <div class="tab-content routa-tab-content">
                <div class="tab-pane fade" :class="{ show: activeTab === 1, active: activeTab === 1 }" style="min-height: 80vh">
                    <weight-distance-price-lists ref="weightRangeLists" @add="addPriceList" @edit="editPriceList"/>
                </div>
                <div class="tab-pane fade" :class="{ show: activeTab === 2, active: activeTab === 2 }" style="min-height: 80vh">
                    <area-price-lists ref="areaLists" @add="addAreaPriceList" @edit="editAreaPriceList"/>
                </div>
            </div>
        </div>
        <base-modal
            v-if="wdEdit"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
            :prevent-close="true"
            @close="priceList=null"
        >
            <price-list-editor
                v-if="priceList"
                :price-list="priceList"
                @close="priceList = null"
                @closeAndUpdate="updateWeightDistanceLists()"
            />
        </base-modal>
        <base-modal
            v-if="areaEdit"
            size="lg"
            :hide-header="true"
            :hide-footer="true"
            :prevent-close="true"
            @close="areaPriceList=null"
        >
            <area-price-list-editor
                v-if="areaPriceList"
                :price-list="areaPriceList"
                @close="areaPriceList = null"
                @closeAndUpdate="updateAreaLists()"
            />
        </base-modal>
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {priceHelper} from "../../mixins/PricingMixin";
import WeightDistancePriceLists from "@/components/pricingmodels/pricelists/WeightDistancePriceLists";
import AreaPriceLists from "@/components/pricingmodels/pricelists/AreaPriceLists";
import PriceListEditor from "@/components/pricingmodels/pricelists/PriceListEditor";
import AreaPriceListEditor from "@/components/pricingmodels/pricelists/AreaPriceListEditor";
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'PriceLists',
    components: {Navbar, BaseModal, AreaPriceListEditor, PriceListEditor, AreaPriceLists, WeightDistancePriceLists},
    mixins: [restApi, priceHelper],
    data: function () {
        return {
            priceList: null,
            areaPriceList: null,
            activeTab: 1,
        }
    },
    computed: {
        wdEdit() {
            return this.priceList != null
        },
        areaEdit() {
            return this.areaPriceList != null
        }
    },
    methods: {
        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },
        updateWeightDistanceLists() {
            this.priceList = null
            this.$refs.weightRangeLists.update()
        },
        addPriceList() {
            this.priceList = this.newPriceList()
        },
        editPriceList(priceList) {
            this.priceList = priceList
        },
        updateAreaLists() {
            this.areaPriceList = null
            this.$refs.areaLists.update()
        },
        addAreaPriceList() {
            this.areaPriceList = this.newAreaPriceList()
        },
        editAreaPriceList(priceList) {
            this.areaPriceList = priceList
        }
    }
}
</script>

<style scoped>
.tab-title {
    font-size: .9em;
    border: none !important;
    margin-right: .5em;
    margin-left: .5em;
    color: #949494 !important;
    font-weight: bold;
}

.tab-title:hover {
    color: #007BFF;
}

.tab-title-active {
    border-bottom: 2px solid #7FC000 !important;
}

.tab-title-text {
    color: #949494 !important;
    font-weight: bold;
}


.tab-title-text-active {
    color: #000000 !important;
    font-weight: bold;
}


.tab-title-cont {
    height: 2.5em !important;
    padding-top: 1em;
    padding-bottom: 1em;
}

</style>
